  <nav  style="    position: fixed;" class="main-menu" id="main-menu" (mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeave()" [ngClass]="{'main-menu-expand': hover}">
    <div class="logo"  class="mt-2" id="sidebaritem">
      <a data-toggle="modal" data-target="#tooltiphomeButtonModal" style="    margin-left: 21px; "  (click)="navigatetoHome()">
      <img *ngIf="hover"                src="../../assets/images/grammarin-logo/grammarin-logo.svg" alt="Expanded Logo" style="width: 150px; margin-top: 25px" >
      <img *ngIf="!hover" src="../../assets/images/grammarin-logo/icon.svg" alt="Collapsed Logo" style="width: 41.56px; margin-top: 25px">
      </a><img src="/assets/images/account setting/logo.svg" style="width: 0px; height: 0px">
    </div>

  <div class="mid_menu">
    <div class="home nav_links" id="sidebaritem" >
      <a class="active menu-btns " data-dismiss="modal" (click)="openSidebar()" #toggleBtn>
    <img id="all-tool" class=" " /> <span
          class=" nav-text">All Tools</span> </a>
    </div>
    <div class="write nav_links" id="sidebaritem" *ngIf="isUserLoggedin">
      <a class="active" (click)="saveTextRedirect('grammar')">
         <img id="write" class="" /> <span
          class=" nav-text">Write</span> </a>
    </div>
    <div class="write nav_links" id="sidebaritem" *ngIf="!isUserLoggedin">
      <a class="active" (click)="onSidebarIconClick()"> <img id="write" class="" />
         <span class=" nav-text">Write</span>
      </a>
    </div>
    <!-- openUpload() -->
    <div class="Upload nav_links" id="sidebaritem" *ngIf="isUserLoggedin" (click)="onIconClick('openUpload')">
      <a data-toggle="modal" data-target="#UpFileModal"> <img id="upload" class="" /> <span
          class=" nav-text">Upload</span> </a>
    </div>
    <div class="Upload nav_links" id="sidebaritem" *ngIf="!isUserLoggedin">
      <a data-toggle="modal" data-target="#UpFileModal" (click)="onSidebarIconClick()"> <img id="upload" class=" " />
        <span class=" nav-text">Upload</span> </a>
    </div>
    <div class="open nav_links" id="sidebaritem" *ngIf="isUserLoggedin" (click)="navigatetoopenfile()">
      <a data-toggle="modal" data-target="#OpenFileModal"> <img id="open" class="" /> <span
          class=" nav-text">Open</span> </a>
    </div>
    <div class="open nav_links" id="sidebaritem" *ngIf="!isUserLoggedin">
      <a data-toggle="modal" data-target="#OpenFileModal" (click)="onSidebarIconClick()"> <img id="open" class="" />
        <span class=" nav-text">Open</span> </a>
    </div>
    <!-- (click)="opensaveFile()" -->
    <div class="save nav_links" id="sidebaritem" *ngIf="isUserLoggedin" (click)="onIconClick('savefile')">
      <a data-toggle="modal" data-target="#SaveModalonlysave"> <img id="save" class="" /> <span
          class=" nav-text">Save</span> </a>
    </div>
    <div class="save nav_links" id="sidebaritem" *ngIf="!isUserLoggedin">
      <a data-toggle="modal" data-target="#SaveModalonlysave" (click)="onSidebarIconClick()"> <img id="save" class="" />
        <span class=" nav-text">Save</span> </a>
    </div>
    <!-- (click)="openDownload()" -->
    <div class="download nav_links" id="sidebaritem" *ngIf="isUserLoggedin" (click)="onIconClick('downloadfile')">
      <a data-toggle="modal" data-target="#DownloadModal"> <img id="donlod" class="" /> <span
          class=" nav-text">Download</span></a>
    </div>
    <div class="download nav_links" id="sidebaritem" *ngIf="!isUserLoggedin">
      <a data-toggle="modal" data-target="#DownloadModal" (click)="onSidebarIconClick()"> <img id="donlod" class="" />
        <span class=" nav-text">Download</span></a>
    </div>
    <div class="share nav_links" id="sidebaritem" *ngIf="isUserLoggedin">
      <a id="btn_tool_download" data-toggle="modal" data-target="#ShareModal" (click)="openShare()"> <img id="share"
          class="" /> <span class=" nav-text">Share</span> </a>
    </div>
    <div class="share nav_links" id="sidebaritem" *ngIf="!isUserLoggedin">
      <a id="btn_tool_download" data-toggle="modal" data-target="#ShareModal" (click)="onSidebarIconClick()"> <img
          id="share" class="" />
        <h6 class=" nav-text">Share</h6>
      </a>
    </div>
    <!-- (click)="openComposeEmail()" -->
    <div class="email_menu nav_links" id="sidebaritem" *ngIf="isUserLoggedin" (click)="onIconClick('sendemail')">
      <a data-toggle="modal" data-target="#EmailModal"> <img id="submission" class="" /> <span class=" nav-text">E
          Submission</span> </a>
    </div>
    <div class="email_menu nav_links" id="sidebaritem" *ngIf="!isUserLoggedin">
      <a data-toggle="modal" data-target="#EmailModal" (click)="onSidebarIconClick()"> <img id="submission" class="" />
        <span class=" nav-text">E Submission</span> </a>
    </div>
    <div class="language_menu nav_links" data-toggle="modal" data-target="#LanguageModal" id="sidebaritem"
      *ngIf="isUserLoggedin" (click)="openLanguage()">
      <a> <img id="langage" class="" /> <span class=" nav-text">Language</span> </a>
    </div>
    <div class="language_menu nav_links" data-toggle="modal" data-target="#LanguageModal" id="sidebaritem"
      *ngIf="!isUserLoggedin">
      <a (click)="onSidebarIconClick()"> <img id="langage" class="" /> <span class=" nav-text">Language</span> </a>
    </div>
    <!-- (click)="openDictionary()"  -->
    <!-- (click)="onIconClick('opendictionary')" -->
    <div class="dictionary_menu nav_links" id="sidebaritem" *ngIf="isUserLoggedin" (click)="  openDictionary()">
      <a data-toggle="modal" data-target="#DictionaryModal"> <img id="dictoray" class="" /> <span
          class=" nav-text">Dictionary</span> </a>
    </div>
    <div class="dictionary_menu nav_links" id="sidebaritem" *ngIf="!isUserLoggedin">
      <a data-toggle="modal" data-target="#DictionaryModal" (click)="onSidebarIconClick()"> <img id="dictoray"
          class="" /> <span class=" nav-text">Dictionary</span> </a>
    </div>
    
  </div>
  <div class="bottom_menu">
    <div class="Account nav_links" id="sidebaritem" *ngIf="isUserLoggedin" (click)="navigatetoaccount()" >
      <a> <img id="account" class="" /> <span class="nav-text">Account</span> </a>
    </div>
    <div class="Account nav_links" id="sidebaritem" *ngIf="!isUserLoggedin">
      <a (click)="onSidebarIconClick()"> <img id="account" class="" /> <span class=" nav-text">Account</span> </a>
    </div>
    <div class="help nav_links" id="sidebaritem" *ngIf="isUserLoggedin" (click)="openSupport()">
      <a data-toggle="modal" data-target="#SupportModal"> <img id="suport" class="" /> <span
          class=" nav-text">Support</span> </a>
      <!-- (click)="navigatetohelpcenter()" -->
    </div>
    <div class="help nav_links" id="sidebaritem" *ngIf="!isUserLoggedin">
      <a data-toggle="modal" data-target="#SupportModal" (click)="onSidebarIconClick()"> <img id="suport" class="" />
        <span class=" nav-text">Support</span> </a>
    </div>
    <div class="Logout nav_links" id="sidebaritem" *ngIf="isUserLoggedin" (click)="openLogout()">
      <a data-toggle="modal" data-target="#logoutButtonModal"> <img id="logout" /> <span class=" nav-text">Logout</span>
      </a>
    </div>
    
  </div>
</nav>
<div class="col-sm p-3 min-vh-100 pt-5">
  <div class="side-bar" id="side-bar" #sidebar>
    <header>
      <div class="d-flex mt-3">
        <h3 class="" style=" margin-left: 100px;
           margin-top: 18px;">All Tools </h3>
        <div class="close-btn"  #closeBtn  (click)="closeSidebr(); preventClose($event)"> <i class="fas fa-times"></i> </div>
      </div>
    </header>
    <div class="mid_menu">
    <div class="menu">
      <ul class="me-4" style="list-style: none" *ngIf="!isUserLoggedin">
        <li>
          <a class="menu-item" (click)="setActive($event, 'document');"
            [ngClass]="{'active': activeItem === 'document'}"> <i class="fa-solid fa-arrow-right me-2"></i>Grammar
            Checker </a>
        </li>
        <li>
          <a class="menu-item" (click)="navigatetoplagifnotloggedin();"> <i
              class="fa-solid fa-arrow-right me-2"></i>Plagiarism Checker </a>
        </li>
        <li>
          <a class="menu-item" (click)="navigatetoparapharsingnotloggedin()"
        > <i
              class="fa-solid fa-arrow-right me-2"></i>Paraphrasing Tool </a>
        </li>
        <li>
          <a class="menu-item" (click)="navigatetoarticlenotloggedin()"> <i class="fa-solid fa-arrow-right me-2"></i>Article
            Rewriter </a>
        </li>
        <li>
          <a class="menu-item" (click)="navigatetotextnotloggedin()"> <i class="fa-solid fa-arrow-right me-2"></i>Text
            Summarizer </a>
        </li>
        <!-- <li>
          <a  class="menu-item" (click)="setActive($event, 'summarizer');navigatetoai()"     [ngClass]="{'active': activeItem === 'summarizer'}">
              <i class="fa-solid fa-arrow-right me-2"></i>AI Text Detector
          </a>
      </li> -->
      </ul>
      <ul class="me-4" style="list-style: none" *ngIf="isUserLoggedin">
        <li>
          <a class="menu-item" (click)="setActive($event, 'document');navigatetogrammar()"
            [ngClass]="{'active': activeItem === 'document'}"> <i class="fa-solid fa-arrow-right me-2"></i>Grammar
            Checker </a>
        </li>
        <li>
          <a class="menu-item" (click)="setActive($event, 'plagiarismchecker');navigatetoplag();"
            [ngClass]="{'active': activeItem === 'plagiarismchecker'}"> <i
              class="fa-solid fa-arrow-right me-2"></i>Plagiarism Checker </a>
        </li>
        <li>
          <a class="menu-item" (click)="setActive($event, 'paraphrasing');navigatetoparapharsing()"
            [ngClass]="{'active': activeItem === 'paraphrasing'}"> <i
              class="fa-solid fa-arrow-right me-2"></i>Paraphrasing Tool </a>
        </li>
        <li>
          <a class="menu-item" (click)="setActive($event, 'article');navigatetoarticle()"
            [ngClass]="{'active': activeItem === 'article'}"> <i class="fa-solid fa-arrow-right me-2"></i>Article
            Rewriter </a>
        </li>
        <li>
          <a class="menu-item" (click)="setActive($event, 'summarizer'); navigatetotext()"
            [ngClass]="{'active': activeItem === 'summarizer'}"> <i class="fa-solid fa-arrow-right me-2"></i>Text
            Summarizer </a>
        </li>
        <!-- <li>
          <a  class="menu-item" (click)="setActive($event, 'summarizer');navigatetoai()"     [ngClass]="{'active': activeItem === 'summarizer'}">
              <i class="fa-solid fa-arrow-right me-2"></i>AI Text Detector
          </a>
      </li> -->
      </ul>
    </div>
    </div>
  </div>
</div>
<router-outlet></router-outlet>

<!-- Modal HTML -->
<div class="modal fade" data-backdrop="static" data-keyboard="false" id="homeButtonModal" tabindex="-1" role="dialog"
  aria-labelledby="homeButtonModalTitle" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" role="document">
    <div class="modal-content">
      <div class="account_badge">
        <button type="button" class="close" aria-label="Close" data-bs-dismiss="modal" aria-label="Close"
          style=" border: none !important; "> <span aria-hidden="true"
            style="color: #000000; margin-right: 10px; height: 14px; width: 14px; font-size: xx-large;"
            (click)="closeHomeButtonModal()">&times;</span> </button>
        <div class="account_badge_inner mt-5"> <span class="upload-title pb-2">
            <h1 style="font-size: 30px;
		   font-weight: 600;
		   margin-top: -35px;
		   line-height: 36px;
		   ;">Create FREE account</h1>
          </span> <span style="    font-size: 20px;
		 font-weight: 400;
		 margin-top: -6px !important;
		 ;
	 ">
            <h6 style="font-size: 20px; font-weight: bolder">to use all features</h6>
          </span>
          <div class="badge_buttons justify-content-center">
            <a id="buttonslogin" data-dismiss="modal" class="btn btn-modal-dark login"
              [routerLink]="['/signin']" >
              <!-- (click)=" navigatetoSignin()"  -->
              Login</a> <a id="buttonslogin" data-dismiss="modal"
              class="btn btn-modal-dark signin"  [routerLink]="['/signup']">
              <!-- (click)=" navigatetoSignUp()" -->
              Sign up</a> </div>
          <div class="account_badge_footer mt-2 d-inline-block mt-3" data-dismiss="modal"> <span
              style="margin-top: 20px; color: #000000; font-size: 16px; font-weight: 500; ;">Login
              with social media</span>
            <br />
          </div>
          <div style="display: flex;justify-content: center;">
          <div id="google" (click)="googleLogin()" style="cursor: pointer;">
            <a> <img src="../../assets/images/google.svg" alt="googlebtn" /> </a>
          </div>
        </div>
          <!-- <div
      id="fb">
			<a >
			  <img src="../../assets/images/fb (1).svg" alt="fbbtn" />
			</a>
			</div> -->
        </div>
      </div>
    </div>
  </div>
</div>
